import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchBranchGroups = ({ accountId }) => get(`/accounts/${accountId}/branch-groups`);

export const addBranchGroup = ({ accountId, branchGroup }) => post(`/accounts/${accountId}/branch-groups`, branchGroup);

export const updateBranchGroup = ({ accountId, branchGroupId, branchGroup }) =>
  patch(`/accounts/${accountId}/branch-groups/${branchGroupId}`, branchGroup);

export const deleteBranchGroup = ({ accountId, branchGroupId }) =>
  httpDelete(`/accounts/${accountId}/branch-groups/${branchGroupId}`);
